import {ReducersMapObject} from "redux";
import aiAssistantReducer from "./ai-assistant/aiAssistantReducer";
import apiReducer, {AllApiState} from "./api/apiReducer";
import appConfigReducer, {AppConfigState} from "./app-config/appConfigReducer";
import appReducer, {AppState} from "./app/appReducer";
import cacheReducer, {DataflowCacheState} from "./cache/cacheReducer";
import catalogReducer from "./catalog/catalogReducer";
import configReducer, {ConfigState} from "./config/configReducer";
import datasetReducer from "./dataset/datasetReducer";
import deleteConflictModalReducer, {DeleteConflictModalState} from "./delete-conflict-modal/deleteConflictModalReducer";
import detailLevelReducer, {DetailLevelState} from "./detail-level/detailLevelReducer";
import hubConfigReducer, {HubConfigState} from "./hub-config/hubConfigReducer";
import hubReducer, {HubState} from "./hub/hubReducer";
import itemContainerReducer, {ItemContainerState} from "./item-container/itemContainerReducer";
import mapsReducer, {MapsState} from "./maps/mapsReducer";
import miscellaneousReducer from "./miscellaneous/miscellaneousReducer";
import moduleConfigsReducer from "./module-configs/moduleConfigsReducer";
import {ModuleConfigsState} from "./module-configs/types";
import nodePermissionsConfigReducer, {
  NodePermissionsConfigState
} from "./node-permissions-config/nodePermissionsConfigReducer";
import nodeReducer, {NodeState} from "./node/nodeReducer";
import nodesConfigReducer, {NodesConfigState} from "./nodes-config/nodesConfigReducer";
import nodeTemplatesConfigReducer, {
  NodesConfigState as NodesTemplateConfigState
} from "./note-templates-config/nodeTemplatesConfigReducer";
import otherConfigReducer, {OtherConfigState} from "./other-config/otherConfigReducer";
import packageManagerReducer from "./package-manager/packageManagerReducer";
import pendingRequestReducer, {PendingRequestState} from "./pending-request/pendingRequestReducer";
import resourceHandlerReducer from "./resource-handler/resourceHandlerReducer";
import searchDialogReducer, {SearchDialogState} from "./search-dialog/searchDialogReducer";
import spinnerReducer, {SpinnerState} from "./spinner/spinnerReducer";
import themeConfigReducer, {ThemeConfigState} from "./theme-config/themeConfigReducer";
import userReducer, {UserState} from "./user/userReducer";
import usersConfigReducer, {UsersConfigState} from "./users-config/usersConfigReducer";

export type RootState = {
  config: ConfigState;
  appConfig: AppConfigState;
  themeConfig: ThemeConfigState;
  moduleConfigs: ModuleConfigsState;
  spinner: SpinnerState;
  pendingRequest: PendingRequestState;
  app: AppState;
  hub: HubState;
  node: NodeState;
  nodeTemplatesConfig: NodesTemplateConfigState;
  catalog: any;
  dataset: ReturnType<typeof datasetReducer>;
  hubConfig: HubConfigState;
  nodesConfig: NodesConfigState;
  cacheConfig: DataflowCacheState;
  otherConfig: OtherConfigState;
  user: UserState;
  usersConfig: UsersConfigState;
  nodePermissionsConfig: NodePermissionsConfigState;
  deleteConflictModal: DeleteConflictModalState;
  maps: MapsState;
  detailLevel: DetailLevelState;
  searchDialog: SearchDialogState;
  api: AllApiState;
  itemContainer: ItemContainerState;
  miscellaneous: any;
  packageManager: any;
  aiAssistant: any;
  resourceHandler: any;
};

const rootReducer: ReducersMapObject<RootState> = {
  config: configReducer,
  appConfig: appConfigReducer,
  themeConfig: themeConfigReducer,
  moduleConfigs: moduleConfigsReducer,
  spinner: spinnerReducer,
  pendingRequest: pendingRequestReducer,
  app: appReducer,
  hub: hubReducer,
  node: nodeReducer,
  nodeTemplatesConfig: nodeTemplatesConfigReducer,
  catalog: catalogReducer,
  dataset: datasetReducer,
  hubConfig: hubConfigReducer,
  nodesConfig: nodesConfigReducer,
  cacheConfig: cacheReducer,
  otherConfig: otherConfigReducer,
  user: userReducer,
  usersConfig: usersConfigReducer,
  nodePermissionsConfig: nodePermissionsConfigReducer,
  deleteConflictModal: deleteConflictModalReducer,
  maps: mapsReducer,
  detailLevel: detailLevelReducer,
  searchDialog: searchDialogReducer,
  api: apiReducer,
  itemContainer: itemContainerReducer,
  miscellaneous: miscellaneousReducer,
  packageManager: packageManagerReducer,
  aiAssistant: aiAssistantReducer,
  resourceHandler: resourceHandlerReducer
};

export default rootReducer;
